import clsx from "clsx";

const Button = ({className, url, target = "_self", children}) => (
    <a
        className={clsx(className, "btn btn-orange")}
        href={url}
        target={target}
        rel={target === "_blank" ? "noopener noreferrer" : ""}
    >
        {children}
    </a>
);

export default Button;
